import { clsx } from "clsx";
import { useMemo, useState, type PropsWithChildren } from "react";

import { Button } from "~/components/Button";

type CategoryItemProps = PropsWithChildren<{
  className?: string;
  isActive?: boolean;
  onClick?: () => void;
}>;

export const CategoryItem = ({
  onClick,
  children,
  className,
  isActive
}: CategoryItemProps) => {
  const [ref, setRef] = useState<HTMLParagraphElement | null>(null);

  const lines = useMemo(() => {
    if (ref === null) return 3;

    const pHeight = ref.offsetHeight;
    const lineHeight = Number(ref.style.lineHeight.replace("px", ""));
    return pHeight / lineHeight;
  }, [ref]);

  return (
    <Button
      className={clsx("h-16 w-full rounded-none", className)}
      size={lines > 2 ? "small" : "medium"}
      variant={isActive ? "info" : "info-inverted"}
      onClick={onClick}
    >
      <p
        className={clsx("line-clamp-3 h-full truncate text-wrap")}
        ref={(newRef) => {
          setRef(newRef);
        }}
        style={{ lineHeight: "18px" }}
      >
        {children}
      </p>
    </Button>
  );
};
